'use strict';

import fr from './fr-CA';
import en from './en-CA';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flatten = (container: Record<string, string>, key: string, value: any, accumulator: string): void => {
  let finalKey = key;
  if (accumulator) {
    finalKey = `${accumulator}.${key}`;
  }

  if (typeof value === 'string') {
    container[finalKey] = value;
  } else {
    Object.keys(value).forEach((key) => {
      flatten(container, key, value[key], finalKey);
    });
  }
};

export const flattenTranslation = (
  translation: Record<string, string | Record<string, unknown>>,
): Record<string, string> => {
  const result = {};
  Object.keys(translation).forEach((key) => {
    flatten(result, key, translation[key], '');
  });
  return result;
};

export default { fr: flattenTranslation(fr), en: flattenTranslation(en) };
